module.exports = loadAsset = (url, type, callback, attr) => {
	//default to script tag if not specified (supports link/script )
	type = type || 'script';
	attr = attr || {};
	//Find first script tag
	var firstScript = window.document.getElementsByTagName('script')[0],
		tag = window.document.createElement( type ),
		attributes = Object.entries( attr );
		//Check for extra attributes to add
		if ( attributes.length > 0 ) {
			for (const [attribute, value] of attributes) {
			  tag.setAttribute(attribute, value);
			}
		}
		//stylesheet settings
		if( type === 'link' ) {
			tag.rel = 'stylesheet'; 
			tag.href = url;
		}

		if( type === 'script' ) {
			tag.src = url;
			tag.async = true;
			tag.defer = true;
		}

	tag.onload = function() {
		typeof callback === 'function' ? callback() : false;
	}

	firstScript.parentNode.insertBefore(tag, firstScript);
	return tag;
}